import React from "react";
import CreateAuthServerCard from "./AuthServerCard";
import { CardTypes } from "./AuthServerCardService";

function AuthServerCardModal({ handleClose, cardType, authServerId }) {
    const isCreateMode = cardType === CardTypes.CREATE;

    return (
        <div className="modal oct_display-block modal-v2-root oct_auth-v2-modal oct_auth-v2-modal--server">
            <div className="modal fade oct_modal show modal-v2-overlay">
                <div className="modal-dialog modal-dialog-centered modal-v2-dialog oct_auth-v2-modal-dialog" aria-modal="true">
                    <div className="modal-content modal-v2-shell oct_auth-v2-modal-shell">
                        <div className="modal-v2-header oct_auth-v2-modal-header">
                            <div className="modal-v2-header-top">
                                <div className="modal-v2-header-copy">
                                    <h2 className="modal-v2-heading">
                                        {isCreateMode ? "Create Authentication Server" : "Edit Authentication Server"}
                                    </h2>
                                    <p className="modal-v2-subheading">
                                        {isCreateMode
                                            ? "Configure a directory or authentication endpoint for external user validation."
                                            : "Update the authentication server details and verify connectivity before saving."}
                                    </p>
                                </div>
                                <button type="button" className="close modal-v2-close" aria-label="Close" onClick={handleClose}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                        </div>

                        <CreateAuthServerCard handleClose={handleClose} cardType={cardType} authServerId={authServerId} />
                    </div>
                </div>
            </div>
        </div>
    )

}


export default AuthServerCardModal;
